/// ----------------------------------------------------------------------------------------
///Copyright (C) 2017 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>toggle-dashboard.component.ts</name>
///
/// <description>
///     Toggle Dashboard
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>31 Oct 2018</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 31Oct18 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";

import { OverlayPanel } from 'primeng/primeng';
import { HydUser } from '../../../models/user';
import { LogService } from '../../../services/log.service';
import { TranslatedStringsService } from '../../../services/language.service';
import { MediatorService } from '../../../services/mediator.service';
import { MediatorEventLookup } from '../../../services/mediator-event-lookup.service';
import { UserAPIService, AppRole } from '../../../services/Crestron.HydrogenAPI.UserApi.service';

@Component({
    selector: 'toggle-dashboard',
  templateUrl: './toggle-dashboard.component.html'
})
export class ToggleDashboardComponent implements OnInit{ 

  @ViewChild('toggleOverlay')
    toggleOverlay: OverlayPanel;  

  private dashboards: Array<Report>; 
  private loadDashboardPermissionsSubscription: Subscription; 

    constructor(
        private hydUser: HydUser,
        private log:LogService,
        private i18n: TranslatedStringsService,
        private mediator: MediatorService,
        private userAPIService: UserAPIService,
        private http: Http,
         private router: Router,
    ) {}


     //----------------------------------------------------------
    //ngOnInit
    //---------------------------------------------------------- 
    public ngOnInit() {

      this.start();
 
    }

  //----------------------------------------------------------
  //onDashboardChange
  //---------------------------------------------------------- 
  private onDashboardChange(event) {

    let report: string = event.value; 
    let destination = "";

    if (this.IsCrestronUser) {
      destination = 'crestron';
    }
    else {
      destination = 'customer';
    } 

    this.router.navigate([this.BaseRoute, { outlets: { 'details': [destination, report] } }], { replaceUrl: true });
    this.toggleOverlay.hide();

  }

  private get BaseRoute(): string {
    let baseRoute: string = "/customer";
    if (this.IsCrestronUser)
      baseRoute = "/crestron";
    return baseRoute;
  }

  //----------------------------------------------- 
  // IsCrestronUser
  //-----------------------------------------------  
  private get IsCrestronUser(): boolean {
    let ret: boolean = false;
    if (this.hydUser && this.hydUser.Roles) {
      let isCrestronUser = this.hydUser.Roles.find(role => { return role.indexOf("Crestron") != -1; });
      if (isCrestronUser)
        ret = true;
    }
    return ret;
  }

  //----------------------------------------------------------
  //start
  //---------------------------------------------------------- 
  private start() {


    this.mediator.Event(MediatorEventLookup.ShowDashboardToggle).subscribe(
      event => {
        //this.signOut = this.i18n.translate('header-signout');
        this.toggleOverlay.toggle(event);
      }
    );

    let inst = this;
    this.loadDashboardPermissionsSubscription = this.getDashboards().subscribe(data => {

      inst.dashboards = data;
      inst.dashboards.forEach(function (report) {
        report.label = report.reportName;
        report.value = report.reportRoute;
      });

    },
    err => {

    });
    


  }

  //-----------------------------------------------
  // stopDashboardPermissionsSubscription
  //-----------------------------------------------
  protected stopDashboardPermissionsSubscription() {

    if (this.loadDashboardPermissionsSubscription)
      this.loadDashboardPermissionsSubscription.unsubscribe();
     
  }

  //----------------------------------------------- 
  // getDashboards
  //-----------------------------------------------  
  private getDashboards(): Observable<any> {

    let headers = new Headers({ 'Accept': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    return this.http.get('app/models/dashboard-permissions.json', options).map((res: Response) => res.json())


  }


}

export class Report {
  public reportName: string
  public reportType: string
  public reportRoute: string;
  public reportId: string;
  public groupId: string;
  public accounts: string[]; 
  public label: string;
  public value: string; 
}




// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/toggle-dashboard/toggle-dashboard.component.ts